import { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import { Alert, Button, Grid, Typography } from '@mui/material'

import { AuthenticationContext } from '../../providers/auth-provider'
import { DashboardContext } from '../../providers/dashboard-provider'
import { formatAddress } from '../../utils/helpers'
import useFolderTree from '../../utils/hooks/useFolderTree'
import useIsMobile from '../../utils/hooks/useIsMobile'
import useLocationSelectModal from '../../utils/hooks/useLocationSelectModal'
import LocationSelectModal from '../location-select-modal'

import useStyles from './index.styles'

const SelectedFolderBanner = ({ folder, isActivation }: { folder: IFolderType | null; isActivation?: boolean }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const isMobile = useIsMobile()
  const { ownUser } = useContext(AuthenticationContext)
  const { selectedFolderId: folderIdContext } = useContext(DashboardContext)
  const { folderId: folderIdState } = (location.state as { folderId?: number | string } | null) || {}
  const selectedFolderId = folderIdContext ?? (folderIdState ? Number(folderIdState) : null)
  const { hasMultipleFolders } = useFolderTree()
  const [showLocationSelectModal, setShowLocationSelectModal] = useLocationSelectModal(selectedFolderId, hasMultipleFolders)
  const classes = useStyles

  const handleLocationChange = () => {
    if (isActivation) {
      navigate('/sensor-folder-assignment')
      return
    }
    setShowLocationSelectModal(true)
  }

  if (!ownUser || !hasMultipleFolders) return null
  return (
    <>
      {folder && (
        <Alert severity="info" icon={false} sx={classes.alert}>
          <Grid container spacing={1} sx={classes.gridContainer}>
            <Grid size={0.5}>
              <PlaceOutlinedIcon sx={classes.locationIcon} fontSize="small" />
            </Grid>

            <Grid size={9} sx={classes.addressGrid}>
              <Typography variant="body2" className="fs-exclude" sx={isMobile ? classes.truncatedText : undefined}>
                {formatAddress(folder.information.address)}
              </Typography>
            </Grid>

            <Grid size={2.5}>
              <Button size="small" variant="text" sx={classes.changeButton} onClick={handleLocationChange}>
                Change
              </Button>
            </Grid>
          </Grid>
        </Alert>
      )}
      <LocationSelectModal
        open={showLocationSelectModal}
        onClose={() => setShowLocationSelectModal(false)}
        onSelect={(newFolderId) => {
          navigate(`/dashboard/${newFolderId}/devices`)
        }}
        selectedFolderId={selectedFolderId}
      />
    </>
  )
}

export default SelectedFolderBanner
